export type AccessPolicy = 'enforce' | 'report-only';

export const accessPolicyOf = (raw: string | undefined): AccessPolicy => (raw === 'report-only' ? 'report-only' : 'enforce');

export const ACCESS_POLICY: AccessPolicy = accessPolicyOf(import.meta.env.VITE_ACCESS_POLICY);
